// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__1Dv-J","inputWrap":"Table_inputWrap__3JbAv","col":"Table_col__ePgPP","bmiTooltip":"Table_bmiTooltip__2YUSM"};